import { BoardStatisticsModel } from "models/BoardStatisticsModel";
import { createContext } from "react";

export interface BoardStatisticsContextProps {
  statistics: BoardStatisticsModel | undefined;
  isLoading: boolean;
}

export const BoardStatisticsContext = createContext({} as BoardStatisticsContextProps);
